import { getApiConfig } from '../config/api.config'
import { authenticatedFetch } from "../features/auth/AuthenticatedService";
import { logger } from '../features/common/logger';
import moment from 'moment';

function getExpiryAgeFromCache(headers:Headers) {
    return headers.get('cache-control')?.split(',')?.find(x=>x.includes('max-age'))?.split('=')[1];
}
export class BaseService {

    public static get baseUrl() {
        return getApiConfig().url.portal.replace(/\/+$/, "");
    }

    public static async AsyncGet(path: string): Promise<any> {
        let url = `${this.baseUrl}${path}`;
        let response = await authenticatedFetch(url);
        if (response.status === 204) {
            return null;
        }
        return await response.json();
    }


    public static async getOrAdd(key:string,path:string){
        let cache = await caches.open(key);
        let matchingItem = await cache.match(path)
        if (matchingItem) {
            let expiresOn = matchingItem.headers.get('expires_on');
            if (expiresOn) {
                let expiresOnDate = moment(expiresOn).toDate();
                let currentDate = new Date();
                if (expiresOnDate > currentDate) {
                    return await matchingItem.json();
                }
            }
            
        }
        let url = `${this.baseUrl}${path}`;
        let response = await authenticatedFetch(url);
        let clonedResponse = response.clone();
        let newHeaders =new Headers(clonedResponse.headers);
        let expiresIn = getExpiryAgeFromCache(newHeaders);
        let currentDate = moment(new Date()).add(parseInt(expiresIn||'3600'),'s');
        newHeaders.append('expires_on',currentDate.toISOString());
        await cache.put(path,new Response(clonedResponse.body,{
            status:clonedResponse.status,
            statusText:clonedResponse.statusText,
            headers:newHeaders
        }));
        return await response.json();
    }


    public static async AsyncAnonymousGet(path: string): Promise<any> {
        let url = `${this.baseUrl}${path}`;
        let response = await fetch(url);
        if (response.status === 204) {
            return null;
        }
        return await response.json();
    }


    public static async AsyncGetFile(path: string): Promise<any> {
        let url = `${this.baseUrl}${path}`;
        let response = await authenticatedFetch(url);
        if (response.status === 204) {
            return null;
        }
        return response;
    }


    public static async AsyncPost(path: string, data: any) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };

        let url = `${this.baseUrl}${path}`;
        let response = await authenticatedFetch(url, requestOptions);
        return await response.json();
    }

    public static async AsyncAnonymousPost(path: string, data: any) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };

        let url = `${this.baseUrl}${path}`;
        let response = await fetch(url, requestOptions);
        return await response.json();
    }

    public static async AsyncPostEmptyBody(path: string) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Content-Length' : '0' }
        };

        let url = `${this.baseUrl}${path}`;
        let response = await authenticatedFetch(url, requestOptions);
        return await response.json();
    }
}
